import { FormContainer } from '@openx/components-core/lib/FormContainer/FormContainer';
import { Loader } from '@openx/components-core/lib/Loader/Loader';
import { PageHeader } from '@openx/components-header/PageHeader';
import { useTranslation } from 'react-i18next';
import { AudienceFormFields } from './AudienceForm/AudienceFormFields';
import { useCreateAudience } from './hooks/useCreateAudience';

export const CreateAudiencePage = () => {
  const { t } = useTranslation();
  const { isLoading, createAndActivateAudience, values } = useCreateAudience();

  if (isLoading) {
    return <Loader />;
  }

  return (
    <PageHeader title={t('Create New Audience')} titlePrefix="OpenXSelect">
      <FormContainer fullPage>
        <AudienceFormFields isCreate={true} formValues={values} onSubmitHandler={createAndActivateAudience} />
      </FormContainer>
    </PageHeader>
  );
};
